module.exports = __webpack_public_path__ + "static/tcdd-digital-marketing-139fc6bbbb6dfb8795adc081e4e14a39.png";